import { IconButton, Menu, MenuItem } from "@material-ui/core";
import { MoreVert } from "@material-ui/icons";
import { useState } from "react";
import { clsx } from "modules/Utils";
import { CurrentBrand } from "modules/Types";

interface BrandActionMenuProps {
    className: string
    handleMenuClick: () => void
    canDelete: boolean
    onDashboardClick: () => void
    openDeleteModal: () => void
    openEditPermissionsModal: () => void
    isAdminOrOwner: boolean
    selectedBrand?: CurrentBrand
}

const BrandActionMenu = ({
    className,
    handleMenuClick,
    canDelete,
    onDashboardClick,
    openDeleteModal, // NOTE: DeleteBrandConfirmationModal
    openEditPermissionsModal,
    isAdminOrOwner,
    selectedBrand,
}: BrandActionMenuProps) => {

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        handleMenuClick();
    };

    const handleCloseSelf = () => {
        setAnchorEl(null);
    };

    return (
        <div
            className={clsx('brandActionMenu', className)}
            onClick={(e) => e.stopPropagation()}
        >
            <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVert />
            </IconButton>
            <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleCloseSelf}
            >
                <MenuItem
                    onClick={() => {
                        onDashboardClick();
                        handleCloseSelf();
                    }}
                >
                    <div className="goToDashboardMenuItem">
                        Go to Dashboard
                    </div>
                </MenuItem>
                {isAdminOrOwner &&
                    <MenuItem
                        onClick={() => {
                            openEditPermissionsModal();
                            handleCloseSelf();
                        }}
                    >
                        <div className="editUserPermissionsMenuItem">
                            Edit User Permissions
                        </div>
                    </MenuItem>
                }
                {isAdminOrOwner && canDelete &&
                    <MenuItem
                        onClick={() => {
                            openDeleteModal();
                            handleCloseSelf();
                        }}
                    >
                        <div className="removeFromTeamMenuItem">
                            Remove from Team
                        </div>
                    </MenuItem>
                }
            </Menu>
        </div>
    );
};

export default BrandActionMenu;